import ScrollerIntro from './components/ScrollerIntro'
import Conclusion from './components/Conclusion'

// Interactives
import './styles/interactives.scss'
import JobAttainment from './components/interactives/job-attainment'
import UnequalDistribution from './components/interactives/unequal-distribution'
import OrganicExposure from './components/interactives/organic-exposure'
import CareerAlignment from './components/interactives/career-alignment'
import SocialCapital from './components/interactives/social-capital'
import Menu from './components/Menu'

export default function App() {
  return (
    <>
      <ScrollerIntro />
      <Menu />
      <div id="job-attainment">
        <JobAttainment />
      </div>
      <div id="unequal-distribution">
        <UnequalDistribution />
      </div>
      <div id="organic-exposure">
        <OrganicExposure />
      </div>
      <div id="career-alignment">
        <CareerAlignment />
      </div>
      <div id="social-capital">
        <SocialCapital />
      </div>
      <Conclusion />
    </>
  )
}
